import { render, staticRenderFns } from "./MenuCartOrder.vue?vue&type=template&id=6d64fea1&scoped=true&"
import script from "./MenuCartOrder.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MenuCartOrder.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MenuCartOrder.vue?vue&type=style&index=0&id=6d64fea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d64fea1",
  null
  
)

export default component.exports